module.exports = __webpack_public_path__ + "static/media/info4.186938b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/info4.png
// module id = 391
// module chunks = 0